module.exports = __webpack_public_path__ + "static/Banner_noon_Tax_63_Mobile.648f8a48.png";